<template>
  <header>
    <img src="@/assets/image/logo.png" alt="Blason" class="blason" />
    <div class="title-container">
      <h1>Après les murs : Cap sur la réinsertion</h1>
      <h3>Répertoire à l’usage des futurs ex-détenus</h3>
    </div>
    <div class="blason-right">
      <img src="@/assets/image/sante_logo.jpg" class="blason2"/>
      <img src="@/assets/image/ville_logo.jpg" class="blason2" />
    </div>
  </header>
  <nav>
    <router-link to="/">Répertoire</router-link> |
    <router-link to="/infos">Infos</router-link> |
    <router-link to="/map">Map</router-link>
  </nav>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1E1C66;
  background-color: #F5F5F5;
}

body{
  margin:0px;
}

header {
  display: flex;
  align-items: center;
  background-color: #167580;
  padding: 1rem;
  color: white;
  position: relative; /* Nécessaire pour que l'image soit positionnée en fonction du header */
}

.title-container {
  flex-grow: 1;
  text-align: center;
}

header h1 {
  font-size: 1.8rem;
  color: white;
  font-weight: bold;
}

nav {
  display: flex;
  justify-content: center;
  background-color: #167580;
  padding: 1rem;
  gap: 2rem;
  border-bottom: 4px solid #D49B3F;
  margin-bottom: 10px;
}

nav a {
  font-weight: bold;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  text-decoration: none;
}

nav a.router-link-exact-active {
  background-color: #D49B3F;
  color: #1E1C66;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
}

nav a:hover {
  background-color: #5E3B80;
  color: white;
}

/* Style pour l'image du blason */
.blason {
  position: absolute;
  top: -8px; /* Décale l'image vers le haut pour qu'elle dépasse */
  left: 10px; /* Positionne l'image à gauche */
  width: 100px; /* Ajuste la taille de l'image */
  height: auto;
}

/* Conteneur logos droite */
.blason-right {
  position: absolute;
  top: -8px;
  right: 10px;
  display: flex;
  gap: 10px;
}

/* Logos droite */
.blason2 {
  width: auto;
  height: 70px;
  border-radius: 0; /* pas d’arrondi */
}

@media (max-width: 768px) {
  .blason{
    width: 50px;
  }
  .title-container{
    margin-top:30px;
  }

  .blason2{
    height:40px;
  }
}
</style>
